//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    universe: string;
    language: string;
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /website-cms/{universe}/pages-language/{language} -> get -> ${code}`);
    };
};

export const Response200IO = t.array(t.interface({
    content: t.string,
    id: t.number,
    keywords: t.union([t.null, t.undefined, t.string]),
    page_description: t.union([t.null, t.undefined, t.string]),
    page_language: t.union([t.null, t.undefined, t.string]),
    seo_title: t.union([t.null, t.undefined, t.string]),
    slug: t.string,
    title: t.string,
    universe: t.string,
}));
export type Response200Type = Array<{
    content: string;
    id: number;
    keywords?: null | undefined | string;
    page_description?: null | undefined | string;
    page_language?: null | undefined | string;
    seo_title?: null | undefined | string;
    slug: string;
    title: string;
    universe: string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response500IO = t.unknown;
export type Response500Type = unknown;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiWebsiteCmsGetPagesRequest"
 */
export const openapi_website_cms_getPages = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/website-cms/${params.universe}/pages-language/${params.language}${query}`;
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiWebsiteCmsGetPagesParamsType = ParamsType;

export type OpenapiWebsiteCmsGetPagesResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiWebsiteCmsGetPagesResponse200Type = Response200Type;

export const openapiWebsiteCmsGetPagesRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiWebsiteCmsGetPagesResponseType> => {
    const response = await openapi_website_cms_getPages(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiWebsiteCmsGetPagesRequest - unhandled response ${response.status}`);
};

